<app-navbar></app-navbar>
<div class="book-a-demo">
  <img src="assets/img/back.png" height="40%" class="background"/>
  <div class="bd-info">
    <p class="heroe-title bold">{{ "LANDING.BOOK_A_DEMO.TITLE" | translate }}</p>
    <p class="bd-subtitle semi-bold">{{ "LANDING.BOOK_A_DEMO.SUBTITLE" | translate }}</p>
    <p class="bd-caption">{{ "LANDING.BOOK_A_DEMO.CAPTION" | translate }}</p>
  </div>
  <app-demo-form ></app-demo-form>
</div>
<app-footer [noCta]="true"></app-footer>
